/**
 * @generated SignedSource<<f849e191b00b830e5d284445fd2a1e8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfirmAddAttachmentInput = {
  attachmentId: string;
  clientMutationId?: string | null;
};
export type imageStripConfirmMutation$variables = {
  input: ConfirmAddAttachmentInput;
};
export type imageStripConfirmMutation$data = {
  readonly confirmAddAttachment: {
    readonly edge: {
      readonly node: {
        readonly dimensions: {
          readonly height: number;
          readonly width: number;
        } | null;
        readonly filename: string;
        readonly filetype: string;
        readonly id: string;
        readonly size: number | null;
        readonly updatedAt: string | null;
        readonly url: string;
      } | null;
    } | null;
  } | null;
};
export type imageStripConfirmMutation = {
  response: imageStripConfirmMutation$data;
  variables: imageStripConfirmMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfirmAddAttachmentPayload",
    "kind": "LinkedField",
    "name": "confirmAddAttachment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SimpleAttachmentEdge",
        "kind": "LinkedField",
        "name": "edge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Attachment",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "filename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "filetype",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageDimensions",
                "kind": "LinkedField",
                "name": "dimensions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "width",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "height",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "imageStripConfirmMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "imageStripConfirmMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a15a6d03258f841e085156160b1f3f41",
    "id": null,
    "metadata": {},
    "name": "imageStripConfirmMutation",
    "operationKind": "mutation",
    "text": "mutation imageStripConfirmMutation(\n  $input: ConfirmAddAttachmentInput!\n) {\n  confirmAddAttachment(input: $input) {\n    edge {\n      node {\n        id\n        filename\n        updatedAt\n        url\n        size\n        filetype\n        dimensions {\n          width\n          height\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "36b9fd59c2df3d834f07ac5892dce3b1";

export default node;
